import axios from 'axios';
import {apiConnector} from './apiconnector'; // Assuming you have a custom API connector
const BASE_URL = process.env.REACT_APP_API_URL; 
const API_URL= `${BASE_URL}/areas`; 
export const getAreas = async () => {
const response = await apiConnector("GET", API_URL,null );
  return response.data;
};

export const createArea = async (area) => {
    const response = await apiConnector("POST", API_URL,area );
  return response.data;
};

export const deleteArea = async (id) => {
    const response = await apiConnector("DELETE", `${API_URL}/${id}`,null );
  return response.data;
};
